module.exports = __webpack_public_path__ + "static/media/6.720dc958.jpg";